export default "__VITE_ASSET__CTG8rXqK__"